import { createApp } from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import "./assets/style.scss";
import { createPinia } from "pinia";
import { createHead } from "@vueuse/head";

const appVue = createApp(App);

// Vuetify expects params as separate arguments: t(key, p0, p1, ...).
// Passing a single array happens to work for {0} (the array is stringified) but
// breaks {1} and beyond, so spread it explicitly.
appVue.config.globalProperties.$t = function (key, params) {
  if (params === undefined) return this.$vuetify.locale.t(key);
  return this.$vuetify.locale.t(key, ...(Array.isArray(params) ? params : [params]));
};

const head = createHead();
appVue.use(router).use(createPinia()).use(vuetify).use(head).mount("#app");
